<template>
    <el-dialog
        class="config_tab_dialog"
        title="标签页配置"
        :visible.sync="openConfigTabDialog"
        top="4%"
        width="30%"
        :before-close="closeDialog">
        <el-table
            :data="tableData"
            height="400"
            style="width: 100%; font-size: 12px;">
            <el-table-column
                prop="tabName"
                label="标签名">
            </el-table-column>
            <el-table-column
                prop="operation"
                label="操作">
                <template slot-scope="scope">
                    <el-switch
                        v-model="tableData[scope.$index].operation">
                    </el-switch>
                </template>
            </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
    <el-button @click="closeDialog">取 消</el-button>
    <el-button type="primary" @click="confirmDialog">确 定</el-button>
  </span>
    </el-dialog>

</template>

<script>
import _ from '@/components/lots/utils';
import { dictWithUrl } from '@/components/lots/api';

export default {
    name: 'config-tab-dialog',
    components: {},
    props: {
        openConfigTabDialog: {
            type: Boolean,
            default() {
                return false;
            }
        },
        tabData: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            tableData: []
        };
    },
    methods: {
        closeDialog() {
            this.$emit('closeDialog', false);
            this.clear();
        },
        confirmDialog() {
            this.$emit('confirmDialog', { data: _.clone(this.tableData), close: false });
            this.clear();
        },
        clear() {
            this.tableData.forEach(tabItem => {
                tabItem.operation = false;
                if (tabItem.id) {
                    tabItem.id = null;
                }
            });
        }
    },
    watch: {
        tabData(val) {
            dictWithUrl('SRM_TAB_TYPE').then(res => {
                if (res && +res.code === 0) {
                    const tabConfigCodes = Object.keys(res.data['SRM_TAB_TYPE']).sort((a, b) => a - b);
                    this.tableData = tabConfigCodes.map(code => {
                        const tableItem = {
                            tabConfigCode: code,
                            tabName: res.data['SRM_TAB_TYPE'][code],
                            operation: false
                        };
                        val.forEach(tabItem => {
                            if (+code === +tabItem.tabConfigCode) {
                                tableItem.id = tabItem.id;
                                tableItem.operation = tabItem.operation;
                            }
                        });
                        return tableItem;
                    });
                }
            });
        }
    }
};
</script>

<style lang="less">
</style>
